import React, { useState } from 'react';

import { Icon } from 'components/ui';

export default function CertificationOverviewHeaderCollapsible({ children }) {
  const [showChildren, setShowChildren] = useState(false);

  return (
    <>
      <div className="CertificationOverviewHeaderCollapsible-mobile">
        {showChildren && children}
        <div className="w-fill ta-c">
          <button
            type="button"
            className="u-resetBtn ml-a mr-a fz-16 c-brand-gray-dark mt-16"
            onClick={() => setShowChildren(!showChildren)}
          >
            {showChildren
              ? t('common.hide_additional_details')
              : t('common.show_additional_details')}
            <Icon
              name={showChildren ? 'caret_up' : 'caret_down'}
              className="ml-4"
            />
          </button>
        </div>
      </div>
      <div className="CertificationOverviewHeaderCollapsible-desktop">
        {children}
      </div>
    </>
  );
}
